<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
  >
    <template #fields="slotProps">
      <div class="toggle-row m-t-8">
        <label for="include_demo" class="small-label">
          Включать в список демо-организации
        </label>
        <InputSwitch
          v-model="slotProps.filter.include_demo"
          inputId="include_demo"
        />
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import InputSwitch from "primevue/inputswitch";

const props = defineProps<{
  isFilterEnabled: boolean;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);

const initialFilter = {};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};
</script>

<style scoped lang="scss">
.toggle-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
</style>
